import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { useMediaQuery } from '@bingads-webui-campaign-react/common-hooks';
import {
  SignupFlowProvider,
  usePostABTestingEventLog,
  usePostPageIdUserNameFlight,
  CUSTOMER_JOURNEY_PRODUCT,
  CUSTOMER_JOURNEY_SUB_PRODUCT,
} from '@bingads-webui-campaign-react/shared-app-capi';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export function SignupFlowProviderWithContext({ children }) {
  const serverContext = useContext(ServerContext);
  const instrumentation = useContext(InstrumentationContext);

  const signupFlowTrace = useMemo(() => {
    if (instrumentation && instrumentation.signupFlowScenario) {
      const scenario = instrumentation.signupFlowScenario.create();
      return scenario.signupFlow.create().trace;
    }
    return _.noop;
  }, [instrumentation]);

  const postABTestingEventLog =
    usePostABTestingEventLog(serverContext, signupFlowTrace);

  const deviceInfo = useMediaQuery();

  const preCIDFlights = [
    {
      ExperimentName: 'PMaxLiteSignup.pmaxlitesignup',
      Flight: 'pmaxlitesignup',
    },
  ];

  const postABTestingFlightLog = usePostPageIdUserNameFlight(serverContext, signupFlowTrace);

  return (
    <SignupFlowProvider
      shouldPost={!!(signupFlowTrace)}
      logWarning={signupFlowTrace}
      postEventLog={postABTestingEventLog}
      serverContext={serverContext}
      deviceInfo={deviceInfo}
      preCIDFlights={preCIDFlights}
      postFlightLog={postABTestingFlightLog}
      product={CUSTOMER_JOURNEY_PRODUCT.PMaxLite}
      subProduct={CUSTOMER_JOURNEY_SUB_PRODUCT.None}
    >
      {children}
    </SignupFlowProvider>
  );
}

SignupFlowProviderWithContext.propTypes = {
  children: PropTypes.node.isRequired,
};
